import type { AgentToolRegistry } from '../AgentToolRegistry';
import { filterTool } from './filterTool';
import { heatmapTool } from './heatmapTool';
import { colorByTool } from './colorByTool';
import { colorMatchTool } from './colorMatchTool';
import { badgeTool } from './badgeTool';
import { labelTool } from './labelTool';
import { highlightTool } from './highlightTool';
import { clearRulesTool } from './clearRulesTool';
import { searchTool } from './searchTool';
import { quickEditTool } from './quickEditTool';
import { suggestTool } from './suggestTool';
import { rdmContextTool } from './rdmContextTool';
import { rdmApplyTool } from './rdmApplyTool';
import { rdmValidateTool } from './rdmValidateTool';
import { rdmSchemaTool } from './rdmSchemaTool';
import { listStartersTool, startFromStarterTool } from './starterTools';

export const registerCoreAgentTools = (registry: AgentToolRegistry): void => {
  registry.register(filterTool);
  registry.register(heatmapTool);
  registry.register(colorMatchTool);
  registry.register(colorByTool);
  registry.register(badgeTool);
  registry.register(labelTool);
  registry.register(highlightTool);
  registry.register(clearRulesTool);
  registry.register(searchTool);
  registry.register(quickEditTool);
  registry.register(suggestTool);
  registry.register(rdmContextTool);
  registry.register(rdmApplyTool);
  registry.register(rdmValidateTool);
  registry.register(rdmSchemaTool);
  registry.register(listStartersTool);
  registry.register(startFromStarterTool);
};
